import axios from "axios";

const Axios = axios.create({
  baseURL: process.env.REACT_APP_API_BASEURL,
  headers: {
    "Content-Type": "application/json",
  },
});

Axios.interceptors.request.use(
  (config) => {
    const publicEndpoints = ['/login', '/loginStaff', '/token', '/api/user/activate', '/api/user/confirmactivate'];
    const isPublicEndpoint = publicEndpoints.some(endpoint => config.url?.includes(endpoint));

    if (!isPublicEndpoint) {
      const token = localStorage.getItem('token_login');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

Axios.interceptors.response.use(
  (response) => response,
  (error) => {
    // ตรวจสอบ 401 Unauthorized
    if (error.response && error.response.status === 401) {
      // เก็บ profile ก่อนล้าง localStorage
      const profile = localStorage.getItem('profile');

      // ล้าง session
      localStorage.clear();

      // Redirect ไปหน้า Login ตาม profile
      if (profile === 'POS') {
        window.location.href = '/login'; // Staff login
      } else {
        window.location.href = '/'; // Customer login
      }
    }
    return Promise.reject(error);
  }
);

export default Axios;

